import React, { useEffect, useState, useContext ,useRef} from 'react';
import {
  DataGridGroup,
  useResponsiveParams,
  Text,
  NotificationList,
  Label,
  Button,
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
} from 'quanta-ui';
// import CurrencyFormater from '../../../../../lib/intl/CurrencyFormater';
import {CurrencyFormater} from'quanta-flows';
import {
  faCalculator,
  faDownload,
  faEnvelope,
  faInfoCircle,
  faShare,
  faSms,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import ModalViewBreakupHealth from '../../../../common/view-breakup/health/view-breakup';
// import {ModalViewBreakupHealth} from 'quanta-flows/modules/common/view-breakup/health/view-breakup';
import {ModalViewBreakupHealth} from 'quanta-flows/modules/common/viewBreakUp';
import { useQuery } from '@apollo/client';
import {
  // CALCULATE_PREMIUM_FOR_PROPOSAL,
  // GET_DATE_TIME,
  GET_GENDER_LIST,
  GET_MEDICAL_QUESTIONS,
  SEND_RENEWAL_EMAIL,
  SEND_RENEWAL_PDF,
  SEND_RENEWAL_SMS,
} from 'quanta-flows/modules/policy/renewal/health';
// import { Error, Loading } from '../../../../../lib/layout';

import { Error,Loading } from 'quanta-flows/modules/layout';
import ModalCoversPlans from './modal-covers-plans';
// import useFetchQuery from '../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
import DownloadAndShare from './download-and-share';
// import { QuantaConfigContext } from '../../../../../lib/config/ConfigProvider';
import {QuantaConfigContext }from 'quanta-flows';
// import useMutationQuery from '../../../../../lib/graphql/useMutationQuery';
import { useMutationQuery } from 'quanta-flows';
// import ModalSendEmail from '../../../../common/common-modals/modal-send-email';
import {ModalSendEmail }from 'quanta-flows/modules/common/modals'
// import ModalSendSms from '../../../../common/common-modals/modal-send-sms';
import {ModalSendSms} from 'quanta-flows/modules/common/modals'
// import { updateViewRenewPolicy } from '../_graphql/state';

import { updateViewRenewPolicy } from 'quanta-flows/modules/policy/renewal/health/state';
import { CALCULATE_PREMIUM_FOR_PROPOSAL ,GET_DATE_TIME} from '../queries';


export default function RenewProposalSummary({
  data: dataViewRenewPolicy,
  productName,
  planName,
  planCode,
  renewalMode,
  productCode,
  renewalFlag,
  ...props
}) {
  const fetchQuery = useFetchQuery();
  const mutateQuery = useMutationQuery();
  const [mounted, setMounted] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [displayRenewalEmailModal, showRenewalEmailModal] =
    useState(false);
  const [displayRenewalSMSModal, showRenewalSMSModal] =
    useState(false);
  const [showDownloadAndShare, setShowDownloadAndShare] =
    useState(false);
  const { branding } = useContext(QuantaConfigContext);

  const validate = (values) => {
    const errors = {};
    if (!values?.planName) {
      errors.planName = '* Required';
    }
    if (!values?.sumInsured) {
      errors.sumInsured = '* Required';
    }
    if (!values?.coverType) {
      errors.coverType = '* Required';
    }
    return errors;
  };

  const {
    loading: loadingGenderList,
    error: errorGenderList,
    data: dataGenderList,
  } = useQuery(GET_GENDER_LIST, { fetchPolicy: 'cache-first' });
  
  const {
    loading: loadingQuestions,
    error: errorQuestions,
    data: dataQuestions,
  } = useQuery(GET_MEDICAL_QUESTIONS, {
    variables: {
      input: {
        productCode,
      },
    },
    fetchPolicy: 'cache-first',
  });
  if (dataViewRenewPolicy) {
    var viewRenewPolicy = dataViewRenewPolicy?.viewRenewPolicy;
    var quoteData = viewRenewPolicy?.quoteData;
    var planData = viewRenewPolicy?.planData;
    var plans = planData?.plans;
  }

  if (dataGenderList) {
    var { genderList } = dataGenderList;
  }
  if (dataQuestions) {
    var { productQuestionList } = dataQuestions;
  }

  useEffect(() => {
    let isMounted = true;
    if (dataViewRenewPolicy && !mounted) {
      setMounted(true);
    }
    return () => {
      isMounted = false;
    };
  }, [
    mounted,
    dataViewRenewPolicy,
    props?.forwardedRenewFormRef?.current,
    props?.forwardedAlertsRef?.current,
  ]);

  const getRenewalInput = () => {
    return {
      input: {
        proposerDetails: {
          id: viewRenewPolicy?.proposerDetails?.id,
          customerType:
            viewRenewPolicy?.proposerDetails?.customerType,
          isThinCustomer: false,
          title: viewRenewPolicy?.proposerDetails?.title,
          gender: viewRenewPolicy?.proposerDetails?.gender,
          firstName: viewRenewPolicy?.proposerDetails?.firstName,
          middleName: viewRenewPolicy?.proposerDetails?.middleName,
          lastName: viewRenewPolicy?.proposerDetails?.lastName,
          fullName: viewRenewPolicy?.proposerDetails?.fullName,
          proposerDOB: viewRenewPolicy?.proposerDetails?.proposerDOB,
          maritalStatus:
            viewRenewPolicy?.proposerDetails?.maritalStatus,
          occupation: viewRenewPolicy?.proposerDetails?.occupation,
          nationality: viewRenewPolicy?.proposerDetails?.nationality,
          idProofType: viewRenewPolicy?.proposerDetails?.idProofType,
          idProofNumber:
            viewRenewPolicy?.proposerDetails?.idProofNumber,
          panNumber: viewRenewPolicy?.proposerDetails?.panNumber,
          orgName: viewRenewPolicy?.proposerDetails?.orgName,
          orgType: viewRenewPolicy?.proposerDetails?.orgType,
          contactName: viewRenewPolicy?.proposerDetails?.contactName,
          regNumber: viewRenewPolicy?.proposerDetails?.regNumber,
          tanNumber: viewRenewPolicy?.proposerDetails?.tanNumber,
          gstNumber: viewRenewPolicy?.proposerDetails?.gstNumber,
          permAddressLine1:
            viewRenewPolicy?.proposerDetails?.permAddressLine1,
          permAddressLine2:
            viewRenewPolicy?.proposerDetails?.permAddressLine2,
          permAddressLine3:
            viewRenewPolicy?.proposerDetails?.permAddressLine3,
          permLandmark:
            viewRenewPolicy?.proposerDetails?.permLandmark,
          permPincode: viewRenewPolicy?.proposerDetails?.permPincode,
          permCityTownVillage:
            viewRenewPolicy?.proposerDetails?.permCityTownVillage,
          permDistrict:
            viewRenewPolicy?.proposerDetails?.permDistrict,
          permState: viewRenewPolicy?.proposerDetails?.permState,
          permCommAddressYN:
            viewRenewPolicy?.proposerDetails?.permCommAddressYN,
          commAddressLine1:
            viewRenewPolicy?.proposerDetails?.commAddressLine1,
          commAddressLine2:
            viewRenewPolicy?.proposerDetails?.commAddressLine2,
          commAddressLine3:
            viewRenewPolicy?.proposerDetails?.commAddressLine3,
          commLandmark:
            viewRenewPolicy?.proposerDetails?.commLandmark,
          commState: viewRenewPolicy?.proposerDetails?.commState,
          commPincode: viewRenewPolicy?.proposerDetails?.commPincode,
          commCityTownVillage:
            viewRenewPolicy?.proposerDetails?.commCityTownVillage,
          commDistrict:
            viewRenewPolicy?.proposerDetails?.commDistrict,
          phoneNo: viewRenewPolicy?.proposerDetails?.phoneNo,
          mobileNo: viewRenewPolicy?.proposerDetails?.mobileNo,
          emailID: viewRenewPolicy?.proposerDetails?.emailID,
          faxNo: viewRenewPolicy?.proposerDetails?.faxNo,
          altPhoneNo: viewRenewPolicy?.proposerDetails?.altPhoneNo,
          altMobileNo: viewRenewPolicy?.proposerDetails?.altMobileNo,
          ifscCode: viewRenewPolicy?.proposerDetailsMeta?.ifscCode,
          bankName: viewRenewPolicy?.proposerDetailsMeta?.bankName,
          branchName:
            viewRenewPolicy?.proposerDetailsMeta?.branchName,
          bankAcno: viewRenewPolicy?.proposerDetailsMeta?.bankAcno,
          accountHolderName:
            viewRenewPolicy?.proposerDetailsMeta?.accountHolderName,
          micrCode: viewRenewPolicy?.proposerDetailsMeta?.micrCode,
        },
        insuredDetails: viewRenewPolicy?.insuredDetails?.map(
          (insured) => {
            let insuredDetailsObj = {};
            insuredDetailsObj.relationship = insured?.relationship;
            insuredDetailsObj.gender = insured?.gender;
            insuredDetailsObj.title = insured?.title;
            insuredDetailsObj.dob = insured?.dob;
            insuredDetailsObj.age = insured?.age;
            insuredDetailsObj.firstName = insured?.firstName;
            insuredDetailsObj.middleName = insured?.middleName;
            insuredDetailsObj.lastName = insured?.lastName;
            insuredDetailsObj.maritalStatus = insured?.maritalStatus;
            insuredDetailsObj.occupation = insured?.occupation;
            insuredDetailsObj.otherOccupation =
              insured?.otherOccupation;
            insuredDetailsObj.height = insured?.height;
            insuredDetailsObj.weight = insured?.weight;
            insuredDetailsObj.pedWaitingPeriod =
              insured?.pedWaitingPeriod;
            insuredDetailsObj.isPortabilityRequired =
              insured?.isPortabilityRequired;
            insuredDetailsObj.cbBonusPct = insured?.cbBonusPct
              ? parseFloat(insured?.cbBonusPct)
              : null;
            insuredDetailsObj.isDeleted = insured?.isDeleted;
            insuredDetailsObj.memberID = insured?.memberID;
            insuredDetailsObj.memberStatus = insured?.memberStatus;
            const nomineeDetailsObj =
              viewRenewPolicy?.nomineeDetails?.find(
                (nominee) =>
                  nominee?.relationship
                    ?.toString()
                    ?.trim()
                    ?.toLowerCase() ===
                  insured?.relationship
                    ?.toString()
                    ?.trim()
                    ?.toLowerCase(),
              );
            insuredDetailsObj.nomineeDetails = {
              name: nomineeDetailsObj?.name
                ? nomineeDetailsObj?.name
                : '',
              dob: nomineeDetailsObj?.dob
                ? nomineeDetailsObj?.dob
                : '',
              relationshipWithInsured:
                nomineeDetailsObj?.relationshipWithInsured
                  ? nomineeDetailsObj?.relationshipWithInsured
                  : '',
              insuredRelationship: insured?.relationship,
              nameOfAppointee: nomineeDetailsObj?.nameOfAppointee
                ? nomineeDetailsObj?.nameOfAppointee
                : '',
              relationshipWithAppointee:
                nomineeDetailsObj?.relationshipWithAppointee
                  ? nomineeDetailsObj?.relationshipWithAppointee
                  : '',
            };

            let medicalQuestionaireObj =
              viewRenewPolicy?.isHealthDeclarationSelected?.toLowerCase() ===
              'yes'
                ? viewRenewPolicy?.medicalQuestionaire?.find(
                    (m) =>
                      m?.relationship?.toLowerCase() ===
                      insured?.relationship?.toLowerCase(),
                  )
                : {
                    relationship: insured?.relationship,
                    questions: [],
                  };

            if (
              medicalQuestionaireObj &&
              medicalQuestionaireObj?.questions?.length > 0
            ) {
              medicalQuestionaireObj = {
                relationship: insured,
                questions: medicalQuestionaireObj?.questions?.map(
                  (question) => {
                    return {
                      srNo: question?.srNo,
                      answer: question?.answer?.answerText,
                    };
                  },
                ),
              };
              medicalQuestionaireObj = {
                ...medicalQuestionaireObj,
                questions:
                  medicalQuestionaireObj?.questions
                    ?.find((q) => q?.srNo?.toLowerCase() === 'master')
                    ?.answer?.toLowerCase() !== 'ye'
                    ? medicalQuestionaireObj?.questions?.filter(
                        (q) => q?.srNo?.toLowerCase() !== '',
                      )
                    : [],
              };
            }
            insuredDetailsObj.medicalQuestionaire =
              medicalQuestionaireObj
                ? medicalQuestionaireObj
                : {
                    relationship: insured?.relationship,
                    questions: [],
                  };

            const { plans } = planData;
            insuredDetailsObj.addOnCovers = plans
              ?.find(
                (p) =>
                  p?.name?.toLowerCase() ===
                  viewRenewPolicy?.planName?.toLowerCase(),
              )
              ?.packs?.filter((pack) =>
                pack?.index?.includes(insured?.relationship),
              )
              .flatMap((pack) =>
                pack.addOnCovers.filter(
                  (addOnCover) => addOnCover.selected,
                ),
              );
            if (!insuredDetailsObj.addOnCovers) {
              insuredDetailsObj.addOnCovers = [];
            }
            const prevInsuranceInput =
              viewRenewPolicy?.prevInsuranceDetails?.find(
                (prevInsured) =>
                  prevInsured?.insuredRelationship?.toLowerCase() ===
                  insured?.relationship?.toLowerCase(),
              );

            insuredDetailsObj.prevInsuranceInput = {
              prevInsurerName: prevInsuranceInput?.prevInsurerName,
              prevPolicyNo: prevInsuranceInput?.prevPolicyNo,
              prevPolicySI: prevInsuranceInput?.prevPolicySI,
              prevClaimLodged:
                prevInsuranceInput?.prevClaimLodged?.toLowerCase() ===
                'yes'
                  ? true
                  : false,
              claimAmount: prevInsuranceInput?.claimAmount,
              prevPolicyStartDate:
                prevInsuranceInput?.prevPolicyStartDate,
              prevPolicyEndDate:
                prevInsuranceInput?.prevPolicyEndDate,
              cbAmount: prevInsuranceInput?.cbAmount,
            };
            return insuredDetailsObj;
          },
        ),
        proposalPaymentType: viewRenewPolicy?.proposalPaymentType,
        quotationType: viewRenewPolicy?.businessType,
        intermediary: {
          intermediaryCode: viewRenewPolicy?.intermediaryDetails?.code
            ? `${viewRenewPolicy?.intermediaryDetails?.code}`
            : '',
          locationCode: viewRenewPolicy?.intermediaryDetails?.location
            ? `${viewRenewPolicy?.intermediaryDetails?.location}`
            : '',
          fieldUserCode: viewRenewPolicy?.intermediaryDetails
            ?.fieldUserCode
            ? `${viewRenewPolicy?.intermediaryDetails?.fieldUserCode}`
            : '',
        },
        startDate: viewRenewPolicy?.policy?.startDate,
        endDate: viewRenewPolicy?.policy?.endDate,
        startTime: '00:00',
        zone: quoteData?.location?.zone,
        coverType: quoteData?.cover?.type,
        sumInsured: quoteData?.cover?.sum_insured
          ? parseInt(quoteData?.cover?.sum_insured)
          : null,
          //dedu
        tenure: quoteData?.cover?.tenure,
        plan: {
          name: viewRenewPolicy?.planName,
          code: planData?.plans?.find(
            (plan) =>
              plan?.name?.toLowerCase() ===
              viewRenewPolicy?.planName?.toLowerCase(),
          )?.code,
          covers: planData?.plans?.find(
            (plan) =>
              plan?.name?.toLowerCase() ===
              viewRenewPolicy?.planName?.toLowerCase(),
          )?.covers
            ? planData?.plans?.find(
                (plan) =>
                  plan?.name?.toLowerCase() ===
                  viewRenewPolicy?.planName?.toLowerCase(),
              )?.covers
            : null,
          packs: planData?.plans?.find(
            (plan) =>
              plan?.name?.toLowerCase() ===
              viewRenewPolicy?.planName?.toLowerCase(),
          )?.packs
            ? planData?.plans?.find(
                (plan) =>
                  plan?.name?.toLowerCase() ===
                  viewRenewPolicy?.planName?.toLowerCase(),
              )?.packs
            : null,
          premium: planData?.plans?.find(
            (plan) =>
              plan?.name?.toLowerCase() ===
              viewRenewPolicy?.planName?.toLowerCase(),
          )?.premium
            ? planData?.plans?.find(
                (plan) =>
                  plan?.name?.toLowerCase() ===
                  viewRenewPolicy?.planName?.toLowerCase(),
              )?.premium
            : null,
        },
        isHealthDeclarationSelected:
          viewRenewPolicy?.isHealthDeclarationSelected?.toLowerCase() ===
          'yes'
            ? true
            : false,
        quoteNumber: viewRenewPolicy?.quoteNumber,
        productCode,
        existingPolicyNumber: dataViewRenewPolicy?.viewRenewPolicy?.Please_provide_existing_policy_number,
        proposerPincode:
          viewRenewPolicy?.quoteData?.location?.pincode ||
          viewRenewPolicy?.proposerDetails?.commPincode,
        renewalMandateDetails: {
          renewalPaymentMandate:
            (viewRenewPolicy?.renewalMandateDetails?.renewalPaymentMandate?.toString()?.toLowerCase() ===
            'yes' || viewRenewPolicy?.renewalMandateDetails?.renewalPaymentMandate ===true)
              ? true
              : false,
          renewalPaymentMandateTakenInNameOf:
            viewRenewPolicy?.renewalMandateDetails
              ?.renewalPaymentMandateTakenInNameOf,
          termForMandateOpted:
            viewRenewPolicy?.renewalMandateDetails
              ?.termForMandateOpted,
          typeOfDebit:
            viewRenewPolicy?.renewalMandateDetails?.typeOfDebit,
          accountNumber:
            viewRenewPolicy?.renewalMandateDetails?.accountNumber,
          destinationBankName:
            viewRenewPolicy?.renewalMandateDetails
              ?.destinationBankName,
          destinationIfscCode:
            viewRenewPolicy?.renewalMandateDetails
              ?.destinationIfscCode,
          destinationMicrCode:
            viewRenewPolicy?.renewalMandateDetails
              ?.destinationMicrCode,
          destinationBranchName:
            viewRenewPolicy?.renewalMandateDetails
              ?.destinationBranchName,
          mandateAmount: parseFloat(
            viewRenewPolicy?.renewalMandateDetails?.mandateAmount,
          ),
          finalCollectionDate:
            viewRenewPolicy?.renewalMandateDetails
              ?.finalCollectionDate,
          destinationBankAccountType:
            viewRenewPolicy?.renewalMandateDetails
              ?.destinationBankAccountType,
        },
        proposalNumber: viewRenewPolicy?.proposalNumber,
        renewalMode,
      },
    };
  };

  const SummaryForm = () => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const [showCoversPlans, setShowCoversPlans] = useState(false);
    const [valuesBeforeEdit, setValuesBeforeEdit] = useState(null);
    const [showViewBreakup, setShowViewBreakup] = useState(false);
    const [fetchingDate, setFetchingDate] = useState(false);
    const [date, setDate] = useState('');
    const [downloadingPDF, setDownloadingPDF] = useState(false);
    const initLoadRef = useRef([]);
    const [isCalculatingPremium, setCalculatingPremium] =
      useState(false);
    const repeatForMobile = 2,
      repeatForDesktop = 1,
      repeatForIPad = 4;
    let repeat = useResponsiveParams({
      for_mobile: repeatForMobile,
      for_desktop: repeatForDesktop,
      for_iPad: repeatForIPad,
    });
    // const {
    //   loading: dateTimeLoading,
    //   error: errorTimeLoading,
    //   data: dateTimeData,
    // } = useQuery(GET_DATE_TIME, {
    //   onCompleted: (data) => {
    //       initLoadRef.current = [...initLoadRef.current, 2];
    //     setDate(dateTimeData?.datetimeValue?.date);
    //   },
    // });
    useEffect(() => {
      if (values?.resetPlanPremium) {
        setFieldValue('planName', '');
        setFieldValue('totalPremium', '');
      }
    }, [
      props?.forwardedRenewFormRef?.current?.values?.insuredDetails
        ? Object.keys(
            props?.forwardedRenewFormRef?.current?.values
              ?.insuredDetails,
          )?.length
        : null,
      props?.forwardedPremiumFormRef?.current?.values
        ?.resetPlanPremium,
      values?.resetPlanPremium,
    ]);
    const getMedicalQuestionsMapped = (values, insured) => {
      let responseObj = {};
      responseObj = {
        relationship: insured,
        questions: Object.keys(
          values?.medicalUnderwriting[`${insured}`],
        ).map((k) => {
          let answerText = '';
          const question = productQuestionList.find(
            (question) => question.srNo === k,
          );
          if (question) {
            if (!question.isParent) {
              const parentQuestion = productQuestionList.find((q) =>
                q.childQuesNo.find(
                  (c) =>
                    c.toLowerCase() === question.srNo.toLowerCase(),
                ),
              );
              if (
                parentQuestion &&
                ((values?.medicalUnderwriting[`${insured}`][
                  `${parentQuestion.srNo}`
                ].checkboxAnswer === 'Yes' &&
                  !parentQuestion.condToChild) ||
                  (values?.medicalUnderwriting[`${insured}`][
                    `${parentQuestion.srNo}`
                  ].checkboxAnswer === 'No' &&
                    parentQuestion.condToChild))
              ) {
                answerText = '';
              } else {
                answerText =
                  question.isChkTxtReq &&
                  values?.medicalUnderwriting[`${insured}`][k] ===
                    'Yes'
                    ? values?.medicalUnderwriting[`${insured}`][k]
                        .textareaAnswer
                    : question.isChkTxtReq &&
                      values?.medicalUnderwriting[`${insured}`][k]
                        .checkboxAnswer === 'No'
                    ? values?.medicalUnderwriting[`${insured}`][k]
                        .checkboxAnswer
                    : question.isChkReq
                    ? values?.medicalUnderwriting[`${insured}`][k]
                        .checkboxAnswer
                    : values?.medicalUnderwriting[`${insured}`][k]
                        .textareaAnswer;
              }
            } else {
              answerText =
                question.isChkTxtReq &&
                values?.medicalUnderwriting[`${insured}`][k]
                  .checkboxAnswer === 'Yes'
                  ? values?.medicalUnderwriting[`${insured}`][k]
                      .textareaAnswer
                  : question.isChkTxtReq &&
                    values?.medicalUnderwriting[`${insured}`][k]
                      .checkboxAnswer === 'No'
                  ? values?.medicalUnderwriting[`${insured}`][k]
                      .checkboxAnswer
                  : question.isChkReq
                  ? values?.medicalUnderwriting[`${insured}`][k]
                      .checkboxAnswer
                  : values?.medicalUnderwriting[`${insured}`][k]
                      .textareaAnswer;
            }
          } else {
            answerText =
              values?.medicalUnderwriting[`${insured}`][k]
                .checkboxAnswer;
          }
          return {
            srNo: k,
            answer: {
              checkboxAnswer:
                values?.medicalUnderwriting[`${insured}`][k]
                  .checkboxAnswer,
              answerText,
              textareaAnswer:
                values?.medicalUnderwriting[`${insured}`][k]
                  .textareaAnswer,
            },
          };
        }),
      };
      return responseObj;
    };

    const getInsuredDetailsObj = (
      val,
      packIdx,
      addOnCoverIdx,
      covers,
    ) => {
      let insuredDetailsArr = [];
      Object.keys(
        props?.forwardedRenewFormRef?.current?.values?.insuredDetails,
      )
        .filter(
          (member) =>
            !props?.forwardedRenewFormRef?.current?.values
              ?.insuredDetails[member]?.isMemberDeleted &&
            !props?.forwardedRenewFormRef?.current?.values
              ?.insuredDetails[member]?.isSoftAdded &&
            !props?.forwardedRenewFormRef?.current?.values
              ?.insuredDetails[member]?.isHardDeleted,
        )
        .forEach((member) => {
          let insuredDetailsObj = {};
          insuredDetailsObj.relationship = member;
          insuredDetailsObj.gender =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.gender;
          insuredDetailsObj.title =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.title;
          insuredDetailsObj.dob =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.dob;
          insuredDetailsObj.age =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.age;
          insuredDetailsObj.firstName =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.firstName;
          insuredDetailsObj.middleName =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.middleName;
          insuredDetailsObj.lastName =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.lastName;
          insuredDetailsObj.maritalStatus =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.maritalStatus;
          insuredDetailsObj.occupation =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.occupation;
          insuredDetailsObj.otherOccupation =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.otherOccupation;
          insuredDetailsObj.maritalStatus =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.maritalStatus;
          insuredDetailsObj.height =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.height;
          insuredDetailsObj.weight =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.weight;
          insuredDetailsObj.pedWaitingPeriod =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.pedWaitingPeriod;
          insuredDetailsObj.nomineeDetails = props
            ?.forwardedRenewFormRef?.current?.values?.nomineeDetails[
            member
          ]
            ? {
                name: props?.forwardedRenewFormRef?.current?.values
                  ?.nomineeDetails[member]?.isSoftAdded
                  ? ''
                  : props?.forwardedRenewFormRef?.current?.values
                      ?.nomineeDetails[member]?.name,
                dob: props?.forwardedRenewFormRef?.current?.values
                  ?.nomineeDetails[member]?.isSoftAdded
                  ? ''
                  : props?.forwardedRenewFormRef?.current?.values
                      ?.nomineeDetails[member]?.dob,
                relationshipWithInsured: props?.forwardedRenewFormRef
                  ?.current?.values?.nomineeDetails[member]
                  ?.isSoftAdded
                  ? ''
                  : props?.forwardedRenewFormRef?.current?.values
                      ?.nomineeDetails[member]
                      ?.relationshipWithInsured,
                insuredRelationship: member,
                nameOfAppointee: props?.forwardedRenewFormRef?.current
                  ?.values?.nomineeDetails[member]?.isSoftAdded
                  ? ''
                  : props?.forwardedRenewFormRef?.current?.values
                      ?.nomineeDetails[member]?.nameOfAppointee,
                relationshipWithAppointee: props
                  ?.forwardedRenewFormRef?.current?.values
                  ?.nomineeDetails[member]?.isSoftAdded
                  ? ''
                  : props?.forwardedRenewFormRef?.current?.values
                      ?.nomineeDetails[member]
                      ?.relationshipWithAppointee,
              }
            : null;
          let medicalQuestionaireObj =
            props?.forwardedRenewFormRef?.current?.values?.isHealthDeclarationSelected?.toLowerCase() ===
            'yes'
              ? getMedicalQuestionsMapped(
                  props?.forwardedRenewFormRef?.current?.values,
                  member,
                )
              : { relationship: member, questions: [] };
          // let medicalQuestionaireObj =
          //   props?.forwardedRenewFormRef?.current?.values?.isHealthDeclarationSelected?.toLowerCase() ===
          //   'yes'
          //     ? viewRenewPolicy?.medicalQuestionaire?.find(
          //         (m) =>
          //           m?.relationship?.toString()?.toLowerCase() ===
          //           member?.toString()?.toLowerCase(),
          //       )
          //     : { relationship: member, questions: [] };
          if (
            medicalQuestionaireObj &&
            medicalQuestionaireObj?.questions &&
            medicalQuestionaireObj?.questions?.length > 0
          ) {
            medicalQuestionaireObj = {
              relationship: member,
              questions: medicalQuestionaireObj?.questions?.map(
                (question) => {
                  return {
                    srNo: question?.srNo,
                    answer: question?.answer?.answerText,
                  };
                },
              ),
            };
            medicalQuestionaireObj = {
              ...medicalQuestionaireObj,
              questions:
                medicalQuestionaireObj?.questions
                  ?.find((q) => q?.srNo?.toLowerCase() === 'master')
                  ?.answer?.toLowerCase() !== 'ye'
                  ? medicalQuestionaireObj?.questions?.filter(
                      (q) => q?.srNo?.toLowerCase() !== '',
                    )
                  : [],
            };
          }
          insuredDetailsObj.medicalQuestionaire =
            medicalQuestionaireObj
              ? medicalQuestionaireObj
              : { relationship: member, questions: [] };
          insuredDetailsObj.addOnCovers = [];
          let addOnCovers = covers ? covers : values?.covers;
          if (
            val !== undefined &&
            packIdx !== undefined &&
            addOnCoverIdx !== undefined
          ) {
            addOnCovers = {
              ...addOnCovers,
              packs: [
                ...addOnCovers?.packs?.slice(0, packIdx),
                {
                  ...addOnCovers?.packs[packIdx],
                  addOnCovers: [
                    ...addOnCovers?.packs[packIdx]?.addOnCovers.slice(
                      0,
                      addOnCoverIdx,
                    ),
                    {
                      ...addOnCovers?.packs[packIdx]?.addOnCovers[
                        addOnCoverIdx
                      ],
                      selected: val,
                    },
                    ...addOnCovers?.packs[packIdx]?.addOnCovers.slice(
                      addOnCoverIdx + 1,
                    ),
                  ],
                },
                ...addOnCovers?.packs?.slice(packIdx + 1),
              ],
            };
          }
          insuredDetailsObj.addOnCovers = addOnCovers?.packs
            ?.filter((pack) => pack?.index?.includes(member))
            ?.flatMap((pack) =>
              pack.addOnCovers.filter(
                (addOnCover) => addOnCover.selected,
              ),
            );
          if (!insuredDetailsObj.addOnCovers) {
            insuredDetailsObj.addOnCovers = [];
          }
          insuredDetailsObj.prevInsuranceInput = {
            prevInsurerName: props?.forwardedRenewFormRef?.current
              ?.values?.prevInsuranceDetails[member]?.isSoftAdded
              ? ''
              : props?.forwardedRenewFormRef?.current?.values
                  ?.prevInsuranceDetails[member]?.prevInsurerName,
            prevPolicyNo: props?.forwardedRenewFormRef?.current
              ?.values?.prevInsuranceDetails[member]?.isSoftAdded
              ? ''
              : props?.forwardedRenewFormRef?.current?.values
                  ?.prevInsuranceDetails[member]?.prevPolicyNo,
            prevPolicySI: props?.forwardedRenewFormRef?.current
              ?.values?.prevInsuranceDetails[member]?.isSoftAdded
              ? ''
              : props?.forwardedRenewFormRef?.current?.values
                  ?.prevInsuranceDetails[member]?.prevPolicySI,
            prevClaimLodged: props?.forwardedRenewFormRef?.current
              ?.values?.prevInsuranceDetails[member]?.isSoftAdded
              ? false
              : props?.forwardedRenewFormRef?.current?.values?.prevInsuranceDetails[
                  member
                ]?.prevClaimLodged?.toLowerCase() === 'yes'
              ? true
              : false,
            claimAmount: props?.forwardedRenewFormRef?.current?.values
              ?.prevInsuranceDetails[member]?.isSoftAdded
              ? ''
              : props?.forwardedRenewFormRef?.current?.values
                  ?.prevInsuranceDetails[member]?.claimAmount,
            prevPolicyStartDate: props?.forwardedRenewFormRef?.current
              ?.values?.prevInsuranceDetails[member]?.isSoftAdded
              ? ''
              : props?.forwardedRenewFormRef?.current?.values
                  ?.prevInsuranceDetails[member]?.prevPolicyStartDate,
            prevPolicyEndDate: props?.forwardedRenewFormRef?.current
              ?.values?.prevInsuranceDetails[member]?.isSoftAdded
              ? ''
              : props?.forwardedRenewFormRef?.current?.values
                  ?.prevInsuranceDetails[member]?.prevPolicyEndDate,
            cbAmount: props?.forwardedRenewFormRef?.current?.values
              ?.prevInsuranceDetails[member]?.isSoftAdded
              ? ''
              : props?.forwardedRenewFormRef?.current?.values
                  ?.prevInsuranceDetails[member]?.cbAmount,
          };
          insuredDetailsObj.isPortabilityRequired =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.isPortabilityRequired;
          insuredDetailsObj.cbBonusPct = props?.forwardedRenewFormRef
            ?.current?.values?.insuredDetails[member]?.cbBonusPct
            ? parseFloat(
                props?.forwardedRenewFormRef?.current?.values
                  ?.insuredDetails[member]?.cbBonusPct,
              )
            : 0;
          insuredDetailsObj.memberID =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.memberID;
          insuredDetailsObj.memberStatus =
            props?.forwardedRenewFormRef?.current?.values?.insuredDetails[
              member
            ]?.memberStatus;
          insuredDetailsArr?.push(insuredDetailsObj);
    });
      return insuredDetailsArr;
    };
    const calculatePremiumForProposalQueryVariables = ({
      val,
      packIdx,
      addOnCoverIdx,
      covers,
      planNameVal,
      date,
    }) => {
      const { crn, isNewCustomer, ...restProposerMetaData } =
        viewRenewPolicy?.proposerDetailsMeta;
      return {
        input: {
          proposerDetails: {
            ...restProposerMetaData,
            ...props?.forwardedRenewFormRef?.current?.values
              ?.proposerDetails,
            isThinCustomer: false,
          },
          insuredDetails: getInsuredDetailsObj(
            val,
            packIdx,
            addOnCoverIdx,
            covers,
          ),
          plan: {
            name: planNameVal ? planNameVal : values?.planName,
            code: plans?.find(
              (p) =>
                p?.name?.toLowerCase() ===
                (planNameVal
                  ? planNameVal?.toLowerCase()
                  : values?.planName?.toLowerCase()),
            )?.code,
          },
          intermediary: {
            intermediaryCode: props?.forwardedRenewFormRef?.current
              ?.values?.intermediaryData?.intermediary
              ? `${props?.forwardedRenewFormRef?.current?.values?.intermediaryData?.intermediary}`
              : '',
            locationCode: props?.forwardedRenewFormRef?.current
              ?.values?.intermediaryData?.businessLocation
              ? `${props?.forwardedRenewFormRef?.current?.values?.intermediaryData?.businessLocation}`
              : '',
            fieldUserCode: props?.forwardedRenewFormRef?.current
              ?.values?.intermediaryData?.fieldUserList?.find(
                (d ) =>  d.fieldUserName === props?.forwardedRenewFormRef?.current
              ?.values?.intermediaryData?.fieldUser
               )?.fieldUserCode,
              // fieldUserCode: proposalDetails?.intermediaryData?.fieldUser 
              // ? proposalDetails?.intermediaryData?.fieldUserList?.find(
              //   (d ) =>  d.fieldUserName === proposalDetails?.intermediaryData?.fieldUser 
              // )?.fieldUserCode
              // : '',
            // fieldUserCode: props?.forwardedRenewFormRef?.current
            //   ?.values?.intermediaryData?.fieldUser
            //   ? `${props?.forwardedRenewFormRef?.current?.values?.intermediaryData?.fieldUser}`
            //   : '',
          },
          zone: '',
          quotationType: viewRenewPolicy?.businessType,
          ProposalNo: viewRenewPolicy?.proposalNumber,
          PolicyNo: viewRenewPolicy?.policyNumber,
          sumInsured: parseFloat(values?.sumInsured),
          deductSumInsured: parseFloat(values?.deductSumInsured),
          startDate: viewRenewPolicy.policy.startDate,
          // date,
          startTime: '00:00',
          tenure: values?.tenure,
          coverType: values?.coverType,
          isHealthDeclarationSelected:
            props?.forwardedRenewFormRef?.current?.values?.isHealthDeclarationSelected?.toLowerCase() ===
            'yes',
          productCode,
          isExistingEmployee:
            props?.forwardedRenewFormRef?.current?.values
              ?.proposerDetails?.employeeNumber !== ''
              ? true
              : false,
          quoteNumber: viewRenewPolicy?.quoteNumber,
          employeeNumber:
            props?.forwardedRenewFormRef?.current?.values
              ?.proposerDetails?.employeeNumber,
          existingPolicyNumber: dataViewRenewPolicy?.viewRenewPolicy?.Please_provide_existing_policy_number,
          proposerPincode:
            props?.forwardedRenewFormRef?.current?.values
              ?.proposerDetails?.commPincode,
          renewalMandateDetails: {
            renewalPaymentMandate:
              (viewRenewPolicy?.renewalMandateDetails?.renewalPaymentMandate?.toString()?.toLowerCase() ===
              'yes' || viewRenewPolicy?.renewalMandateDetails?.renewalPaymentMandate ===true)
                ? true
                : false,
            renewalPaymentMandateTakenInNameOf:
              viewRenewPolicy?.renewalMandateDetails
                ?.renewalPaymentMandateTakenInNameOf,
            termForMandateOpted:
              viewRenewPolicy?.renewalMandateDetails
                ?.termForMandateOpted,
            typeOfDebit:
              viewRenewPolicy?.renewalMandateDetails?.typeOfDebit,
            accountNumber:
              viewRenewPolicy?.renewalMandateDetails?.accountNumber,
            destinationBankName:
              viewRenewPolicy?.renewalMandateDetails
                ?.destinationBankName,
            destinationIfscCode:
              viewRenewPolicy?.renewalMandateDetails
                ?.destinationIfscCode,
            destinationMicrCode:
              viewRenewPolicy?.renewalMandateDetails
                ?.destinationMicrCode,
            destinationBranchName:
              viewRenewPolicy?.renewalMandateDetails?.branchName,
            mandateAmount: parseFloat(
              viewRenewPolicy?.renewalMandateDetails?.mandateAmount,
            ),
            finalCollectionDate:
              viewRenewPolicy?.renewalMandateDetails
                ?.finalCollectionDate,
            destinationBankAccountType:
              viewRenewPolicy?.renewalMandateDetails
                ?.destinationBankAccountType,
          },
        },
      };
    };

    let renewProposalSummaryDataDesktopView = [
      {
        grid_data: [
          {
            label: (
              <Text type="label" severity="info">
                Expiry Policy Number
              </Text>
            ),
            colSpan: 1,
            text: viewRenewPolicy?.policyNumber ? (
              <Text type="normal">
                {viewRenewPolicy?.policyNumber}
              </Text>
            ) : (
              <Text type="normal" severity="neutral">
                Not Captured
              </Text>
            ),
          },
          {
            label: (
              <Text type="label" severity="info">
                Proposal Number
              </Text>
            ),
            colSpan: 1,
            text: viewRenewPolicy?.proposalNumber ? (
              <Text type="normal">
                {viewRenewPolicy?.proposalNumber}
              </Text>
            ) : (
              <Text type="normal" severity="neutral">
                Not Captured
              </Text>
            ),
          },
          {
            label: (
              <Text type="label" severity="info">
                Proposal Status
              </Text>
            ),
            colSpan: 1,
            text: viewRenewPolicy?.proposalStatus ? (
              <Text type="normal">
                {viewRenewPolicy?.proposalStatus}
              </Text>
            ) : (
              <Text type="normal" severity="neutral">
                Not Captured
              </Text>
            ),
          },
          {
            colSpan: 1,
            text: (
              <div className="flex items-end justify-between mt-2">
                <span>
                  <Label text="Plan Name" severity="info">
                    <Text
                      type="normal"
                      severity={
                        !plans?.find(
                          (plan) =>
                            plan?.name?.toLowerCase() ===
                            viewRenewPolicy?.planName?.toLowerCase(),
                        )
                          ? 'neutral'
                          : undefined
                      }
                    >
                      {viewRenewPolicy?.planLoading ? (
                        <Loading
                          textSize="normal"
                          customMessage={'Checking Availability'}
                          className="flex justify-start items-center space-x-2 text-opacity-50 text-primary w-full"
                        />
                      ) : plans?.find(
                        (plan) =>
                          plan?.name?.toLowerCase() ===
                          viewRenewPolicy?.planName?.toLowerCase(),
                        )?.name ? (
                        plans?.find(
                            (plan) =>
                              plan?.name?.toLowerCase() ===
                              viewRenewPolicy?.planName?.toLowerCase(),
                          )?.name
                      ) : (
                        'Not Captured'
                      )}
                    </Text>
                  </Label>
                </span>
                {!viewRenewPolicy?.planLoading && (
                <span>
                  <Button
                    type="button"
                    size="small"
                    onClick={async (_) => {
                      try {
                        const fetchDate = fetchQuery({
                          query: GET_DATE_TIME,
                        });
                        setFetchingDate(true);
                        const { data: dataTimeValue } =
                          await fetchDate;
                          // console.log("datetimevalue1114",dataTimeValue)
                        setDate(dataTimeValue?.datetimeValue?.date);
                        setFetchingDate(false);
                        setShowCoversPlans(true);
                        setValuesBeforeEdit(values);
                      } catch (error) {
                        setFetchingDate(false);
                      }
                    }}
                    className="w-40"
                    iconPre={
                      fetchingDate ? (
                        <FontAwesomeIcon
                          icon={faSpinner}
                          spin={true}
                        />
                      ) : undefined
                    }
                    disabled={
                        fetchingDate ||
                        !values?.isPlansAndCoversEditable ||
                        isCalculatingPremium ||
                        viewRenewPolicy?.isProposalRenewing || renewalFlag?.toString()?.toLowerCase() === 'expired'
                    }
                    flat={viewRenewPolicy?.planName ? true : false}
                  >
                      {viewRenewPolicy?.isProposalRenewed
                        ? 'View Details'
                        : fetchingDate
                      ? 'Fetching Details'
                      : viewRenewPolicy?.planName
                      ? 'View/Edit Details'
                      : 'Choose Plan'}
                  </Button>
                </span>
                )}
              </div>
            ),
          },
          {
            label: (
              <Text type="label" severity="info">
                Tenure
              </Text>
            ),
            colSpan: 1,
            text: values?.tenure ? (
              <Text type="normal">{values?.tenure}</Text>
            ) : (
              <Text type="normal" severity="neutral">
                Not Captured
              </Text>
            ),
          },
          {
            label: (
              <Text type="label" severity="info">
                Sum Insured
              </Text>
            ),
            colSpan: 1,
            text:
              quoteData?.cover?.sum_insured !== undefined &&
              quoteData?.cover?.sum_insured !== null ? (
                <Text type="normal">
                  {CurrencyFormater(
                    quoteData?.cover?.sum_insured !== null &&
                      quoteData?.cover?.sum_insured !== undefined
                      ? quoteData?.cover?.sum_insured?.toString()
                      : '',
                    true,
                    false,
                    branding,
                  )}
                </Text>
              ) : (
                <Text type="normal" severity="neutral">
                  Not Captured
                </Text>
              ),
          },
          {
            colSpan: 1,
            text: (
              <div className="flex flex-col items-start justify-start mt-2">
                {!(
                  !viewRenewPolicy?.totalPremium &&
                  viewRenewPolicy?.planName
                ) && (
                <span>
                  <Text severity="info" type="label">
                    Annual Premium (inclusive of taxes)
                  </Text>
                </span>
                )}
                <span className="flex justify-start space-x-2 items-center w-full">
                  {viewRenewPolicy?.premiumLoading ? (
                    <Text type={'normal'} severity={'info'}>
                      <Loading
                        textSize="normal"
                        customMessage={'Calculating Premium'}
                        className="flex justify-start items-center space-x-2 text-opacity-50 text-primary w-full"
                      />
                    </Text>
                  ) : viewRenewPolicy?.totalPremium ? (
                    <>
                      <Text type={'larger'} severity={'info'}>
                        {CurrencyFormater(
                          viewRenewPolicy?.totalPremium,
                          true,
                          false,
                          branding,
                        )}
                      </Text>
                      <div
                        className="quanta_link mt-1 font-normal"
                        onClick={(_) => setShowViewBreakup(true)}
                      >
                        View Breakup
                      </div>
                    </>
                  ) : viewRenewPolicy?.planName ? (
                    <Text
                      type="normal"
                      severity="neutral"
                      className={'w-full mb-4'}
                    >
                      <Button
                        size={'small'}
                        type={'button'}
                        className={'w-full'}
                        iconPre={
                          isCalculatingPremium ? (
                            <FontAwesomeIcon
                              icon={faSpinner}
                              spin={true}
                              size={'1x'}
                              className={'ml-5 -mr-2'}
                            />
                          ) : (
                            <FontAwesomeIcon
                              icon={faCalculator}
                              size={'1x'}
                              className={'ml-5 -mr-2'}
                            />
                          )
                        }
                        disabled={isCalculatingPremium}
                        onClick={async (_) => {
                          try {
                            props.forwardedAlertsRef.current = [];
                            props?.forwardedRenewFormRef?.current?.setFieldValue(
                              'isCalculatingPremium',
                              true,
                            );
                            setCalculatingPremium(true);
                            const fetchDate = fetchQuery({
                              query: GET_DATE_TIME,
                            });
                            const { data: dataTimeValue } =
                              await fetchDate;
                              // console.log("data1275",dataTimeValue)
                            const calculatePremiumQuery = fetchQuery({
                              query: CALCULATE_PREMIUM_FOR_PROPOSAL,
                              variables:
                                calculatePremiumForProposalQueryVariables(
                                  {
                                    planNameVal: values?.planName,
                                    covers: planData?.plans?.find(
                                      (p) =>
                                        p?.name?.toLowerCase() ===
                                        values?.planName?.toLowerCase(),
                                    ),
                                    date: dataTimeValue?.datetimeValue
                                      ?.date,
                                  },
                                ),
                            });
                            const { data: premiumData } =
                              await calculatePremiumQuery;
                            setCalculatingPremium(false);
                            const { warningMsg, ...restPremiumData } =
                              premiumData?.calculatePremiumForProposalST;
                            updateViewRenewPolicy({
                              planData: {
                                plans: [
                                  ...plans?.filter(
                                    (p) =>
                                      p?.name?.toLowerCase() !==
                                      values?.planName?.toLowerCase(),
                                  ),
                                  {
                                    ...plans?.find(
                                      (p) =>
                                        p?.name?.toLowerCase() ===
                                        values?.planName?.toLowerCase(),
                                    ),
                                    packs: values?.covers?.packs,
                                    premium: restPremiumData,
                                  },
                                ],
                              },
                              prevPlanData: {
                                plans: [
                                  ...plans?.filter(
                                    (p) =>
                                      p?.name?.toLowerCase() !==
                                      values?.planName?.toLowerCase(),
                                  ),
                                  {
                                    ...plans?.find(
                                      (p) =>
                                        p?.name?.toLowerCase() ===
                                        values?.planName?.toLowerCase(),
                                    ),
                                    packs: values?.covers?.packs,
                                    premium: restPremiumData,
                                  },
                                ],
                              },
                              prevPlanName: values?.planName,
                              premiumLoading: false,
                              prevTotalPremium:
                                premiumData
                                  ?.calculatePremiumForProposalST
                                  ?.totalPremium,
                              quoteData: {
                                ...quoteData,
                                cover: {
                                  ...quoteData?.cover,
                                  type: values?.coverType,
                                  sum_insured: values?.sumInsured,
                                },
                              },
                              planName: values?.planName,
                              planCode: plans?.find(
                                (plan) =>
                                  plan?.name?.toLowerCase() ===
                                  values?.planName?.toLowerCase(),
                              )?.code,
                              totalPremium:
                                premiumData
                                  ?.calculatePremiumForProposalST
                                  ?.totalPremium,
                            });
                            props.forwardedAlertsRef.current =
                              premiumData?.calculatePremiumForProposalST
                                ?.warningMsg
                                ? [
                                    {
                                      id: Date.now(),
                                      content: (
                                        <div>
                                          Annual Premium updated successfully
                                        </div>
                                      ),
                                      timeout: 7000,
                                      disableClose: false,
                                      type: 'info',
                                    },
                                    {
                                      id: Date.now() * 1234,
                                      content: (
                                        <div>
                                          {
                                            premiumData
                                              ?.calculatePremiumForProposalST
                                              ?.warningMsg
                                          }
                                        </div>
                                      ),
                                      timeout: null,
                                      disableClose: false,
                                      type: 'warning',
                                    },
                                  ]
                                : [
                                    {
                                      id: Date.now(),
                                      content: (
                                        <div>
                                          Annual Premium updated successfully
                                        </div>
                                      ),
                                      timeout: 7000,
                                      disableClose: false,
                                      type: 'info',
                                    },
                                  ];
                            props?.forwardedRenewFormRef?.current?.setFieldValue(
                              'isCalculatingPremium',
                              false,
                            );
                          } catch (error) {
                            setCalculatingPremium(false);
                            //Unexpected Token - Health Renewal
            if(error?.message?.includes("Unexpected token")){
              setResultPremiumError('Please try again after sometime');
            }
            //Unexpected Token - Health Renewal
                            updateViewRenewPolicy({
                              premiumLoading: false,
                            });
                            props.forwardedAlertsRef.current = [
                              {
                                id: Date.now(),
                                header: 'Error Calculating Premium',
                                content: <div>{error?.message}</div>,
                                timeout: null,
                                disableClose: false,
                                type: 'error',
                              },
                            ];
                            props?.forwardedRenewFormRef?.current?.setFieldValue(
                              'isCalculatingPremium',
                              false,
                            );
                          }
                        }}
                      >
                        {isCalculatingPremium
                          ? 'Calculating ...'
                          : 'Calculate Premium'}
                      </Button>
                    </Text>
                  ) : (
                    <Text type="normal" severity="neutral">
                      Not Captured
                    </Text>
                  )}
                </span>
              </div>
            ),
          },
          {
            colSpan: 1,
            text: (
              <span className="flex flex-col items-end justify-end py-2 w-full h-full">
                <Button
                  flat={true}
                  type={'button'}
                  size="medium"
                  className="w-full"
                  disabled={
                    !viewRenewPolicy?.isProposalRenewed ||
                    downloadingPDF
                  }
                  onClick={async (_) => {
                    try {
                      const downloadRenewalPDF = mutateQuery({
                        mutation: SEND_RENEWAL_PDF,
                        variables: getRenewalInput(),
                      });
                      setDownloadingPDF(true);
                      const { data: dataBase64String } =
                        await downloadRenewalPDF;
                      const { sendRenewalPDF } = dataBase64String;
                      const { base64Pdf: downloadBase64String } =
                        sendRenewalPDF;
                      setDownloadingPDF(false);

                      let byteCharacters = atob(
                        downloadBase64String.toString(),
                      );
                      let byteNumbers = new Array(
                        byteCharacters.length,
                      );
                      for (
                        let i = 0;
                        i < byteCharacters.length;
                        i++
                      ) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                      }
                      let byteArray = new Uint8Array(byteNumbers);
                      let file = new Blob([byteArray], {
                        type: 'application/pdf;base64',
                      });
                      let fileURL = URL.createObjectURL(file);
                      window.open(fileURL);
                    } catch (error) {
                      setAlerts([
                        {
                          id: Date.now(),
                          content: (
                            <div className="flex flex-col w-full h-full">
                              <Text type="normal">
                                {error.message}
                              </Text>
                            </div>
                          ),
                          type: 'error',
                          timeout: null,
                          disableClose: false,
                        },
                      ]);
                      setDownloadingPDF(false);
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
                >
                  <div className="flex justify-start space-x-8 items-center w-full">
                    <span>
                      {downloadingPDF ? (
                        <FontAwesomeIcon
                          icon={faSpinner}
                          size="lg"
                          className="ml-3"
                          spin={true}
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={faDownload}
                          size="lg"
                          className="ml-3"
                        />
                      )}
                    </span>
                    <span>
                      {downloadingPDF
                        ? 'Downloading Renewal...'
                        : 'Download Renewal Proposal'}
                    </span>
                  </div>
                </Button>
              </span>
            ),
          },
          {
            colSpan: 1,
            text: (
              <span className="flex flex-col items-end justify-end py-2 w-full h-full">
                <Button
                  flat={true}
                  type={'button'}
                  size="medium"
                  className="w-full"
                  disabled={!viewRenewPolicy?.isProposalRenewed}
                  onClick={(_) => showRenewalEmailModal(true)}
                >
                  <div className="flex justify-start space-x-12 items-center w-full">
                    <span>
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        size="lg"
                        className="ml-3"
                      />
                    </span>
                    <span>Email Renewal Proposal</span>
                  </div>
                </Button>
              </span>
            ),
          },
          {
            colSpan: 1,
            text: (
              <span className="flex flex-col items-end justify-end py-2 w-full h-full">
                <Button
                  flat={true}
                  type={'button'}
                  size="medium"
                  className="w-full"
                  disabled={!viewRenewPolicy?.isProposalRenewed}
                  onClick={(_) => showRenewalSMSModal(true)}
                >
                  <div className="flex justify-start space-x-12 items-center w-full">
                    <span>
                      <FontAwesomeIcon
                        icon={faSms}
                        size="lg"
                        className="ml-3"
                      />
                    </span>
                    <span>Message Renewal Proposal</span>
                  </div>
                </Button>
              </span>
            ),
          },
        ].filter((d) => d),
      },
    ];

    let renewalProposalSummaryDataMobileView = [
      {
        grid_data: [
          {
            label: (
              <Text type="label" severity="info">
                Plan Name
              </Text>
            ),
            colSpan: 1,
            text: (
              <div
                className={`flex items-center justify-start space-x-2`}
              >
                <span>
                  <Text
                    type="large"
                    className={
                      !plans?.find(
                        (plan) =>
                          plan?.name?.toLowerCase() ===
                          viewRenewPolicy?.planName?.toLowerCase(),
                      )?.name
                        ? 'text-neutral-darker'
                        : undefined
                    }
                  >
                    {viewRenewPolicy?.planLoading ? (
                      <Loading
                        textSize="normal"
                        customMessage={'Checking Availability'}
                        className="flex justify-start items-center space-x-2 text-opacity-50 text-primary w-full text-xs whitespace-nowrap"
                      />
                    ) : plans?.find(
                      (plan) =>
                        plan?.name?.toLowerCase() ===
                        viewRenewPolicy?.planName?.toLowerCase(),
                      )?.name ? (
                      plans?.find(
                          (plan) =>
                            plan?.name?.toLowerCase() ===
                            viewRenewPolicy?.planName?.toLowerCase(),
                        )?.name
                    ) : null}
                  </Text>
                </span>
                {!viewRenewPolicy?.planLoading && (
                <span>
                  {plans?.find(
                    (plan) =>
                      plan?.name?.toLowerCase() ===
                      viewRenewPolicy?.planName?.toLowerCase(),
                  )?.name ? (
                      <Text
                        type="label"
                        severity="action"
                        className=""
                      >
                      <Button
                        className={`w-auto h-7 ${
                          fetchingDate ||
                            !values?.isPlansAndCoversEditable ||
                            isCalculatingPremium || viewRenewPolicy?.isProposalRenewing
                            ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                            : ''
                        }`}
                        flat
                        size="small"
                        type="button"
                        onClick={async (_) => {
                          if (
                            !fetchingDate &&
                              values?.isPlansAndCoversEditable &&
                              !isCalculatingPremium && 
                              !viewRenewPolicy?.isProposalRenewing
                          ) {
                            try {
                              const fetchDate = fetchQuery({
                                query: GET_DATE_TIME,
                              });
                              setFetchingDate(true);
                              const { data: dataTimeValue } =
                                await fetchDate;
                              
                              setDate(
                                dataTimeValue?.datetimeValue?.date,
                              );
                              setFetchingDate(false);
                              setShowCoversPlans(true);
                              setValuesBeforeEdit(values);
                            } catch (error) {
                              setFetchingDate(false);
                            }
                          }
                        }}
                      >
                          {viewRenewPolicy?.isProposalRenewed ? 'View':'Edit'}
                      </Button>
                    </Text>
                  ) : (
                    <div className="-ml-2">
                      <Button
                        flat={false}
                        className="w-28"
                        type={'button'}
                        iconPre={
                          fetchingDate ? (
                            <FontAwesomeIcon
                              icon={faSpinner}
                              spin={true}
                            />
                          ) : undefined
                        }
                        disabled={fetchingDate}
                        size={'small'}
                        onClick={async (_) => {
                          try {
                            const fetchDate = fetchQuery({
                              query: GET_DATE_TIME,
                            });
                            setFetchingDate(true);
                            const { data: dataTimeValue } =
                              await fetchDate;
                              // console.log("1717",dataTimeValue)
                            setDate(
                              dataTimeValue?.datetimeValue?.date,
                            );
                            setFetchingDate(false);
                            setShowCoversPlans(true);
                            setValuesBeforeEdit(values);
                          } catch (error) {
                            setFetchingDate(false);
                          }
                        }}
                      >
                        Choose Plan
                      </Button>
                    </div>
                  )}
                </span>
                )}
              </div>
            ),
          },
          {
            label: (
              <Text type="label" severity="info">
                Proposal Status
              </Text>
            ),
            colSpan: 1,
            text: viewRenewPolicy?.proposalStatus ? (
              <Text type="normal">
                {viewRenewPolicy?.proposalStatus}
              </Text>
            ) : (
              <Text type="normal" severity="neutral-darker">
                Not Captured
              </Text>
            ),
          },
          {
            label: (
              <Text
                type="label"
                severity="info"
                className="whitespace-nowrap"
              >
                Annual Premium (inclusive of taxes)
              </Text>
            ),
            colSpan: 1,
            text: viewRenewPolicy?.premiumLoading ? (
              <Text type={'normal'} severity={'info'}>
                <Loading
                  textSize="normal"
                  customMessage={'Calculating Premium'}
                  className="flex justify-start items-center space-x-2 text-opacity-50 text-primary w-full text-xs whitespace-nowrap"
                />
              </Text>
            ) : viewRenewPolicy?.totalPremium ? (
                <div className="flex items-center justify-start space-x-2">
                  <span>
                  <Text
                    type={
                      viewRenewPolicy?.totalPremium?.toString()
                        ?.length <= 5
                        ? 'larger'
                        : 'normal'
                    }
                    severity="info"
                  >
                    {CurrencyFormater(
                      viewRenewPolicy?.totalPremium,
                        true,
                        false,
                        branding,
                      )}
                    </Text>
                  </span>
                  <span
                    className="pt-0.5"
                    onClick={(_) => setShowViewBreakup(true)}
                  >
                    <Text type="normal" severity="info">
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </Text>
                  </span>
                </div>
            ) : viewRenewPolicy?.planName ? (
              <Button
                type={'button'}
                size={'small'}
                className={'w-full'}
                iconPre={
                  isCalculatingPremium ? (
                    <FontAwesomeIcon
                      icon={faSpinner}
                      spin={true}
                      size={'1x'}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faCalculator}
                      size={'1x'}
                    />
                  )
                }
                disabled={isCalculatingPremium}
                onClick={async (_) => {
                  try {
                    props.forwardedAlertsRef.current = [];
                    props?.forwardedRenewFormRef?.current?.setFieldValue(
                      'isCalculatingPremium',
                      true,
                    );
                    setCalculatingPremium(true);
                    const fetchDate = fetchQuery({
                      query: GET_DATE_TIME,
                    });
                    const { data: dataTimeValue } = await fetchDate;
                    // console.log("datatimevalue1834",dataTimeValue)
                    const calculatePremiumQuery = fetchQuery({
                      query: CALCULATE_PREMIUM_FOR_PROPOSAL,
                      variables:
                        calculatePremiumForProposalQueryVariables({
                          planNameVal: values?.planName,
                          covers: planData?.plans?.find(
                            (p) =>
                              p?.name?.toLowerCase() ===
                              values?.planName?.toLowerCase(),
                          ),
                          date: dataTimeValue?.datetimeValue?.date,
                        }),
                    });
                    const { data: premiumData } =
                      await calculatePremiumQuery;
                    const { warningMsg, ...restPremiumData } =
                      premiumData?.calculatePremiumForProposalST;
                    setCalculatingPremium(false);
                    updateViewRenewPolicy({
                      planData: {
                        plans: [
                          ...plans?.filter(
                            (p) =>
                              p?.name?.toLowerCase() !==
                              values?.planName?.toLowerCase(),
                          ),
                          {
                            ...plans?.find(
                              (p) =>
                                p?.name?.toLowerCase() ===
                                values?.planName?.toLowerCase(),
                            ),
                            packs: values?.covers?.packs,
                            premium: restPremiumData,
                          },
                        ],
                      },
                      prevPlanData: {
                        plans: [
                          ...plans?.filter(
                            (p) =>
                              p?.name?.toLowerCase() !==
                              values?.planName?.toLowerCase(),
                          ),
                          {
                            ...plans?.find(
                              (p) =>
                                p?.name?.toLowerCase() ===
                                values?.planName?.toLowerCase(),
                            ),
                            packs: values?.covers?.packs,
                            premium: restPremiumData,
                          },
                        ],
                      },
                      prevPlanName: values?.planName,
                      prevTotalPremium:
                        premiumData?.calculatePremiumForProposalST
                          ?.totalPremium,
                      quoteData: {
                        ...quoteData,
                        cover: {
                          ...quoteData?.cover,
                          type: values?.coverType,
                          sum_insured: values?.sumInsured,
                        },
                      },
                      planName: values?.planName,
                      planCode: plans?.find(
                        (plan) =>
                          plan?.name?.toLowerCase() ===
                          values?.planName?.toLowerCase(),
                      )?.code,
                      totalPremium:
                        premiumData?.calculatePremiumForProposalST
                          ?.totalPremium,
                    });
                    props.forwardedAlertsRef.current = premiumData
                      ?.calculatePremiumForProposalST?.warningMsg
                      ? [
                          {
                            id: Date.now(),
                            content: (
                              <div>
                                Annual Premium updated
                                successfully
                              </div>
                            ),
                            timeout: 7000,
                            disableClose: false,
                            type: 'info',
                          },
                          {
                            id: Date.now() * 1234,
                            content: (
                              <div>
                                {
                                  premiumData
                                    ?.calculatePremiumForProposalST
                                    ?.warningMsg
                                }
                              </div>
                            ),
                            timeout: null,
                            disableClose: false,
                            type: 'warning',
                          },
                        ]
                      : [
                          {
                            id: Date.now(),
                            content: (
                              <div>
                                Annual Premium updated
                                successfully
                              </div>
                            ),
                            timeout: 7000,
                            disableClose: false,
                            type: 'info',
                          },
                        ];
                    props?.forwardedRenewFormRef?.current?.setFieldValue(
                      'isCalculatingPremium',
                      false,
                    );
                  } catch (error) {
                    setCalculatingPremium(false);
                    //Unexpected Token - Health Renewal
                    if(error?.message?.includes("Unexpected token")){
                      setResultPremiumError('Please try again after sometime');
                    }
                      //Unexpected Token - Health Renewal
                    props.forwardedAlertsRef.current = [
                      {
                        id: Date.now() * 1234,
                        content: <div>{error?.message}</div>,
                        timeout: null,
                        disableClose: false,
                        type: 'error',
                      },
                    ];
                    props?.forwardedRenewFormRef?.current?.setFieldValue(
                      'isCalculatingPremium',
                      false,
                    );
                  }
                }}
              >
                {isCalculatingPremium
                  ? 'Calculating ...'
                  : 'Calculate Premium'}
              </Button>
              ) : (
                <Text severity="neutral-darker" type="normal">
                  Not Captured
                </Text>
              ),
          },
          {
            colSpan: 1,
            text: (
              <Button
                flat
                type={'button'}
                size="small"
                onClick={() =>
                  viewRenewPolicy?.isProposalRenewed
                    ? setShowDownloadAndShare(true)
                    : null
                }
                className={`w-auto mt-4 ${
                  !viewRenewPolicy?.isProposalRenewed
                    ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                    : ''
                }`}
                iconPre={
                  <FontAwesomeIcon
                    icon={faShare}
                    size="sm"
                    className="mr-1"
                  />
                }
              >
                Download & Share
              </Button>
            ),
          },
        ].filter((d) => d),
      },
    ];
    let renewalProposalSummaryDataIPadView = [
      {
        grid_data: [
          {
            label: (
              <Text type="label" severity="info">
                Plan Name
              </Text>
            ),
            colSpan: 1,
            className: `${
              plans?.find(
                (plan) =>
                  plan?.name?.toLowerCase() ===
                  viewRenewPolicy?.planName?.toLowerCase(),
              )?.name
                ? 'mt-0.5'
                : ''
            }`,
            text: (
              <div
                className={`flex items-center justify-start space-x-2`}
              >
                <span>
                  <Text
                    type="large"
                    className={
                      !plans?.find(
                        (plan) =>
                          plan?.name?.toLowerCase() ===
                          viewRenewPolicy?.planName?.toLowerCase(),
                      )?.name
                        ? 'text-neutral-darker'
                        : undefined
                    }
                  >
                    {viewRenewPolicy?.planLoading ? (
                      <Loading
                        textSize="normal"
                        customMessage={'Checking Availability'}
                        className="flex justify-start items-center space-x-2 text-opacity-50 text-primary w-full text-xs whitespace-nowrap"
                      />
                    ) : plans?.find(
                      (plan) =>
                        plan?.name?.toLowerCase() ===
                        viewRenewPolicy?.planName?.toLowerCase(),
                      )?.name ? (
                      plans?.find(
                          (plan) =>
                            plan?.name?.toLowerCase() ===
                            viewRenewPolicy?.planName?.toLowerCase(),
                        )?.name
                    ) : null}
                  </Text>
                </span>
                {!viewRenewPolicy?.planLoading && (
                <span>
                  {plans?.find(
                    (plan) =>
                      plan?.name?.toLowerCase() ===
                      viewRenewPolicy?.planName?.toLowerCase(),
                  )?.name ? (
                    <Text type="normal" severity="action">
                      <Button
                        className={`w-auto h-7 ${
                          fetchingDate ||
                            !values?.isPlansAndCoversEditable ||
                            isCalculatingPremium ||
                            viewRenewPolicy?.isProposalRenewing
                            ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                            : ''
                        }`}
                        size="small"
                        type="button"
                        flat
                        onClick={async (_) => {
                          if (
                            !fetchingDate &&
                              values?.isPlansAndCoversEditable &&
                              !isCalculatingPremium &&
                              !viewRenewPolicy?.isProposalRenewing
                          ) {
                            try {
                              const fetchDate = fetchQuery({
                                query: GET_DATE_TIME,
                              });
                              setFetchingDate(true);
                              const { data: dataTimeValue } =
                                await fetchDate;
                                // console.log("2109",dataTimeValue)
                              setDate(
                                dataTimeValue?.datetimeValue?.date,
                              );
                              setFetchingDate(false);
                              setShowCoversPlans(true);
                              setValuesBeforeEdit(values);
                            } catch (error) {
                              setFetchingDate(false);
                            }
                          }
                        }}
                      >
                          {viewRenewPolicy?.isProposalRenewed ? 'View':'Edit'}
                      </Button>
                    </Text>
                  ) : (
                    <div className="-ml-2">
                      <Button
                        flat={false}
                        className="w-28"
                        type={'button'}
                        iconPre={
                          fetchingDate ? (
                            <FontAwesomeIcon
                              icon={faSpinner}
                              spin={true}
                            />
                          ) : undefined
                        }
                        disabled={fetchingDate}
                        size={'small'}
                        onClick={async (_) => {
                          try {
                            const fetchDate = fetchQuery({
                              query: GET_DATE_TIME,
                            });
                            setFetchingDate(true);
                            const { data: dataTimeValue } =
                              await fetchDate;
                              // console.log("datatimevalue2148",dataTimeValue)
                            setDate(
                              dataTimeValue?.datetimeValue?.date,
                            );
                            setFetchingDate(false);
                            setShowCoversPlans(true);
                            setValuesBeforeEdit(values);
                          } catch (error) {
                            setFetchingDate(false);
                          }
                        }}
                      >
                        Choose Plan
                      </Button>
                    </div>
                  )}
                </span>
                )}
              </div>
            ),
          },
          {
            colSpan: 1,
            text: (
              <div className="flex items-center justify-start space-x-2 mt-3">
                <span>
                  <Label
                    text="Annual Premium (inclusive of taxes)"
                    severity="info"
                    className="whitespace-nowrap"
                  >
                    {viewRenewPolicy?.premiumLoading ? (
                      <Text type={'normal'} severity={'info'}>
                        <Loading
                          textSize="normal"
                          customMessage={'Calculating Premium'}
                          className="flex justify-start items-center space-x-2 text-opacity-50 text-primary w-full text-xs whitespace-nowrap"
                        />
                      </Text>
                    ) : viewRenewPolicy?.totalPremium ? (
                      <Text type="larger" severity="info">
                        <div className="flex items-center space-x-2">
                          <span>
                            {CurrencyFormater(
                               viewRenewPolicy?.totalPremium,
                              true,
                              false,
                              branding,
                            )}
                          </span>
                          <span
                            className="pb-1"
                            onClick={(_) => setShowViewBreakup(true)}
                          >
                            <Text type="normal" severity="info">
                              <FontAwesomeIcon icon={faInfoCircle} />
                            </Text>
                          </span>
                        </div>
                      </Text>
                    ) : viewRenewPolicy?.planName ? (
                      <Button
                        type={'button'}
                        size={'small'}
                        className={'w-full'}
                        iconPre={
                          isCalculatingPremium ? (
                            <FontAwesomeIcon
                              icon={faSpinner}
                              spin={true}
                              size={'1x'}
                            />
                          ) : (
                            <FontAwesomeIcon
                              icon={faCalculator}
                              size={'1x'}
                            />
                          )
                        }
                        disabled={isCalculatingPremium}
                        onClick={async (_) => {
                          try {
                            props.forwardedAlertsRef.current = [];
                            props?.forwardedRenewFormRef?.current?.setFieldValue(
                              'isCalculatingPremium',
                              true,
                            );
                            setCalculatingPremium(true);
                            const fetchDate = fetchQuery({
                              query: GET_DATE_TIME,
                            });
                            const { data: dataTimeValue } =
                              await fetchDate;
                              // console.log("datatime value2240",dataTimeValue)
                            const calculatePremiumQuery = fetchQuery({
                              query: CALCULATE_PREMIUM_FOR_PROPOSAL,
                              variables:
                                calculatePremiumForProposalQueryVariables(
                                  {
                                    planNameVal: values?.planName,
                                    covers: planData?.plans?.find(
                                      (p) =>
                                        p?.name?.toLowerCase() ===
                                        values?.planName?.toLowerCase(),
                                    ),
                                    date: dataTimeValue?.datetimeValue
                                      ?.date,
                                  },
                                ),
                            });
                            const { data: premiumData } =
                              await calculatePremiumQuery;
                            const { warningMsg, ...restPremiumData } =
                              premiumData;
                            setCalculatingPremium(false);
                            updateViewRenewPolicy({
                              planData: {
                                plans: [
                                  ...plans?.filter(
                                    (p) =>
                                      p?.name?.toLowerCase() !==
                                      values?.planName?.toLowerCase(),
                                  ),
                                  {
                                    ...plans?.find(
                                      (p) =>
                                        p?.name?.toLowerCase() ===
                                        values?.planName?.toLowerCase(),
                                    ),
                                    packs: values?.covers?.packs,
                                    premium: restPremiumData,
                                  },
                                ],
                              },
                              prevPlanData: {
                                plans: [
                                  ...plans?.filter(
                                    (p) =>
                                      p?.name?.toLowerCase() !==
                                      values?.planName?.toLowerCase(),
                                  ),
                                  {
                                    ...plans?.find(
                                      (p) =>
                                        p?.name?.toLowerCase() ===
                                        values?.planName?.toLowerCase(),
                                    ),
                                    packs: values?.covers?.packs,
                                    premium: restPremiumData,
                                  },
                                ],
                              },
                              prevPlanName: values?.planName,
                              prevTotalPremium:
                                premiumData
                                  ?.calculatePremiumForProposalST
                                  ?.totalPremium,
                              quoteData: {
                                ...quoteData,
                                cover: {
                                  ...quoteData?.cover,
                                  type: values?.coverType,
                                  sum_insured: values?.sumInsured,
                                },
                              },
                              planName: values?.planName,
                              planCode: plans?.find(
                                (plan) =>
                                  plan?.name?.toLowerCase() ===
                                  values?.planName?.toLowerCase(),
                              )?.code,
                              totalPremium:
                                premiumData
                                  ?.calculatePremiumForProposalST
                                  ?.totalPremium,
                            });
                            props.forwardedAlertsRef.current =
                              premiumData?.calculatePremiumForProposalST
                                ?.warningMsg
                                ? [
                                    {
                                      id: Date.now(),
                                      content: (
                                        <div>
                                          Annual Premium updated successfully
                                        </div>
                                      ),
                                      timeout: 7000,
                                      disableClose: false,
                                      type: 'info',
                                    },
                                    {
                                      id: Date.now() * 1234,
                                      content: (
                                        <div>
                                          {
                                            premiumData
                                              ?.calculatePremiumForProposalST
                                              ?.warningMsg
                                          }
                                        </div>
                                      ),
                                      timeout: null,
                                      disableClose: false,
                                      type: 'warning',
                                    },
                                  ]
                                : [
                                    {
                                      id: Date.now(),
                                      content: (
                                        <div>
                                          Annual Premium updated successfully
                                        </div>
                                      ),
                                      timeout: 7000,
                                      disableClose: false,
                                      type: 'info',
                                    },
                                  ];
                            props?.forwardedRenewFormRef?.current?.setFieldValue(
                              'isCalculatingPremium',
                              false,
                            );
                          } catch (error) {
                            setCalculatingPremium(false);
                            //Unexpected Token - Health Renewal
            if(error?.message?.includes("Unexpected token")){
              setResultPremiumError('Please try again after sometime');
            }
            //Unexpected Token - Health Renewal
                            props.forwardedAlertsRef.current = [
                              {
                                id: Date.now() * 1234,
                                content: <div>{error?.message}</div>,
                                timeout: null,
                                disableClose: false,
                                type: 'error',
                              },
                            ];
                            props?.forwardedRenewFormRef?.current?.setFieldValue(
                              'isCalculatingPremium',
                              false,
                            );
                          }
                        }}
                      >
                        {isCalculatingPremium
                          ? 'Calculating ...'
                          : 'Calculate Premium'}
                      </Button>
                    ) : (
                      <Text
                        type="large"
                        className="text-neutral-darker"
                      >
                        Not Captured
                      </Text>
                    )}
                  </Label>
                </span>
              </div>
            ),
          },
          {
            label: (
              <Text type="label" severity="info">
                {'Proposal Number & Status'}
              </Text>
            ),
            colSpan: 1,
            className: 'mt-1',
            text: (
              <Text type="large" className="whitespace-nowrap">
                {viewRenewPolicy?.proposalNumber ? (
                  viewRenewPolicy?.proposalNumber
                ) : (
                  <Text type="large" className="text-neutral-darker">
                    Not Captured
                  </Text>
                )}
                {' , '}
                {`${viewRenewPolicy?.proposalNumber} , ${viewRenewPolicy?.proposalStatus}`
                  .length > 30 ? (
                  <br />
                ) : null}
                {viewRenewPolicy?.proposalStatus ? (
                  viewRenewPolicy?.proposalStatus
                ) : (
                  <Text type="large" className="text-neutral-darker">
                    Not Captured
                  </Text>
                )}
              </Text>
            ),
          },
          {
            colSpan: 1,
            text: (
              <span className="flex justify-end">
                <Button
                  flat={true}
                  type={'button'}
                  size="medium"
                  className={`w-auto mt-2 ${
                    !viewRenewPolicy?.isProposalRenewed
                      ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                      : ''
                  }`}
                  onClick={(_) =>
                    viewRenewPolicy?.isProposalRenewed
                      ? setShowDownloadAndShare(true)
                      : null
                  }
                >
                  <div className="flex justify-start w-full">
                    <span>
                      <FontAwesomeIcon
                        icon={faShare}
                        size="sm"
                        className="mr-1"
                      />
                    </span>
                    <span>{'Download & Share'}</span>
                  </div>
                </Button>
              </span>
            ),
          },
        ].filter((d) => d),
      },
    ];

    return (
      <>
        <QuantaForm>
          <DataGridGroup
            data={
              repeat === repeatForDesktop
                ? renewProposalSummaryDataDesktopView
                : repeat === repeatForMobile
                ? renewalProposalSummaryDataMobileView
                : renewalProposalSummaryDataIPadView
            }
            repeat={repeat}
            textType="label"
            titleType="title"
            titleSeverity="info"
            className="w-full"
            gap={0}
            gapX={16}
            isSeparatorRequired={false}
            gapY={2}
            spaceY={2}
            nullData={() => (
              <Text className="opacity-40">Not Captured</Text>
            )}
          />
          <div>
            <ModalCoversPlans
              {...{
                showCoversPlans,
                setShowCoversPlans,
                planData,
                quoteData,
                forwardedRef: props?.forwardedPremiumFormRef,
                forwardedAlertsRef: props?.forwardedAlertsRef,
                forwardedRenewFormRef: props?.forwardedRenewFormRef,
                date,
                productCode,
                productName,
                planName,
                planCode,
                renewalMode,
                viewRenewPolicy,
                proposalDetails:
                  props?.forwardedRenewFormRef?.current?.values,
                valuesBeforeEdit: valuesBeforeEdit,
                productQuestionList,
              }}
            />
          </div>
          <div>
            <ModalViewBreakupHealth
              {...{
                showViewBreakup,
                setShowViewBreakup,
                selectedPlanTypeView: viewRenewPolicy?.planName,
                productName,
                productCode,
                planName,
                planCode,
                renewalMode,
                genderList,
                reactive_var_quote: quoteData,
                reactive_var_plan: planData,
                title: 'Premium Breakup for Renewal',
              }}
            />
          </div>
        </QuantaForm>
      </>
    );
  };
  const initialValues = {
    resetPlanPremium: false,
    isPlansAndCoversEditable:
      viewRenewPolicy?.isProposalReadyForRenewal,
    coverType: quoteData?.cover?.type ? quoteData?.cover?.type : '',
    sumInsured:
      quoteData?.cover?.sum_insured !== null &&
      quoteData?.cover?.sum_insured !== undefined
        ? quoteData?.cover?.sum_insured?.toString()
        : '',
    deductSumInsured: quoteData?.cover?.deductSumInsured !== null &&
    quoteData?.cover?.deductSumInsured !== undefined
      ? quoteData?.cover?.deductSumInsured?.toString()
      : '',
    tenure: quoteData?.cover?.tenure ? quoteData?.cover?.tenure : '',
    planName: viewRenewPolicy?.planName,
    planCode: viewRenewPolicy?.planCode,
    premium: plans?.find(
      (plan) =>
        plan?.name?.toString()?.toLowerCase() ===
        viewRenewPolicy?.planName?.toString()?.toLowerCase(),
    )?.premium,
    totalPremium: viewRenewPolicy?.totalPremium,
    covers: {
      baseCovers:
        plans?.length > 0
          ? plans?.find(
              (p) =>
                p?.name?.toLowerCase() ===
                viewRenewPolicy?.planName?.toLowerCase(),
            )?.covers
          : [],
      packs:
        plans?.length > 0
          ? plans?.find(
              (p) =>
                p?.name?.toLowerCase() ===
                viewRenewPolicy?.planName?.toLowerCase(),
            )?.packs
          : [],
    },
  };

  return (
    <>
      {loadingGenderList || loadingQuestions ? (
        <Loading />
      ) : errorGenderList || errorQuestions ? (
        <Error error={errorGenderList || errorQuestions} />
      ) : (
        <>
          <QuantaFormik
            innerRef={props?.forwardedPremiumFormRef}
            enableReinitialise={true}
            {...{ initialValues, validate }}
          >
            <SummaryForm />
          </QuantaFormik>
          <div>
            <NotificationList
              {...{
                items: [
                  ...alerts,
                  ...props?.forwardedAlertsRef?.current,
                ],
              }}
            />
          </div>
          <div>
            <ModalSendEmail
              {...{
                SEND_EMAIL_QUERY: SEND_RENEWAL_EMAIL,
                getPayLoad: (email, ccEmailIds) => {
                  return {
                    ...getRenewalInput(),
                    email,
                    ccEmailIds,
                  };
                },
                initialEmail:
                  getRenewalInput()?.input?.proposerDetails?.emailID,
                setShowEmail: showRenewalEmailModal,
                showEmail: displayRenewalEmailModal,
              }}
            />
          </div>
          <div>
            <ModalSendSms
              {...{
                SEND_SMS_QUERY: SEND_RENEWAL_SMS,
                getPayLoad: (
                  mobile,
                  alternateMobileNos,
                  whatsappNo,
                  modes,
                ) => {
                  return {
                    ...getRenewalInput(),
                    mobile,
                    alternateMobileNos,
                    whatsappNo,
                    modes,
                  };
                },
                initialMobile:
                  getRenewalInput()?.input?.proposerDetails?.mobileNo,
                setShowSms: showRenewalSMSModal,
                showSms: displayRenewalSMSModal,
              }}
            />
          </div>
          <div>
            <DownloadAndShare
              {...{
                showDownloadAndShare,
                setShowDownloadAndShare,
                renewalInput: getRenewalInput(),
              }}
            />
          </div>
        </>
      )}
    </>
  );
}
